import { clamp } from '@shopify/polaris-viz-core';
import { TOOLTIP_POSITION_DEFAULT_RETURN } from '../constants.js';
import { eventPointNative, getXYFromEventType } from './eventPoint.js';

function getLineChartTooltipPosition({
  containerBounds,
  chartBounds,
  data,
  event,
  eventType,
  index,
  isTouchDevice,
  longestSeriesIndex,
  scrollY,
  xScale
}) {
  if (eventType === 'mouse' && (event instanceof MouseEvent || event instanceof TouchEvent)) {
    if (event == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const point = eventPointNative(event);
    if (point == null || xScale == null || data[longestSeriesIndex] == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const {
      svgX
    } = point;
    const closestIndex = Math.round(xScale.invert(svgX - chartBounds.x));
    const activeIndex = clamp({
      amount: closestIndex,
      min: 0,
      max: data[longestSeriesIndex].data.length - 1
    });
    const {
      x,
      y
    } = getXYFromEventType(event);
    return {
      x: isTouchDevice ? xScale(activeIndex) : x,
      y,
      activeIndex
    };
  } else {
    var _xScale;
    const activeIndex = index !== null && index !== void 0 ? index : 0;
    const x = (_xScale = xScale === null || xScale === void 0 ? void 0 : xScale(activeIndex)) !== null && _xScale !== void 0 ? _xScale : 0;
    return {
      x: x + containerBounds.x,
      y: containerBounds.y - scrollY,
      activeIndex
    };
  }
}

export { getLineChartTooltipPosition };
